import { SESSION_CARD_VARIANTS, SessionCardVariant } from '@/lib/feature-flags';
import { cn } from '@/lib/utils';

import { TrialTag } from './trial-tag';

const APEX_GLOW_STYLE: React.CSSProperties = {
  width: '23.375rem',
  height: '23.375rem',
  borderRadius: '23.375rem',
  background: '#6034F2',
  filter: 'blur(85.05px)',
  top: '-13rem',
  right: '-10rem',
};

const CANCELLED_GLOW_STYLE: React.CSSProperties = {
  width: '23.375rem',
  height: '23.375rem',
  borderRadius: '23.375rem',
  background: 'var(--color-fusion-red-dark)',
  filter: 'blur(85.05px)',
  top: '-13rem',
  right: '-18rem',
};

function sessionCardGlow(isCancelled: boolean, isApex: boolean) {
  if (isCancelled) return CANCELLED_GLOW_STYLE;
  if (isApex) return APEX_GLOW_STYLE;
  return null;
}

export function UpcomingSessionCardDiv({
  isSecondSession = false,
  variant = SESSION_CARD_VARIANTS.DEFAULT,
  showTrialTag = false,
  trialSessionNumber,
  isCancelled = false,
  onClick,
  children,
}: Readonly<{
  isSecondSession?: boolean;
  variant?: SessionCardVariant;
  showTrialTag?: boolean;
  trialSessionNumber?: number;
  isCancelled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}>) {
  const isClickable = isSecondSession && onClick;
  const isApex = variant === SESSION_CARD_VARIANTS.APEX;
  const glowStyle = sessionCardGlow(isCancelled, isApex);

  return (
    <div className="relative h-full">
      {showTrialTag ? <TrialTag sessionNumber={trialSessionNumber} /> : null}
      <div
        className={cn(
          'relative rounded-3xl p-6 text-white lg:max-w-lg flex flex-col gap-4 h-full overflow-hidden',
          isApex && 'bg-magical-moonlight-d3',
          !isApex &&
            (isSecondSession
              ? 'bg-gradient-to-bl from-magical-moonlight-d3 from-50% to-bhanzu-orange to-95%'
              : 'bg-gradient-to-tr from-magical-moonlight-d3 from-50% to-bhanzu-orange to-95%'),
          isClickable && 'cursor-pointer hover:opacity-90 transition-opacity'
        )}
        onClick={onClick}
        onKeyDown={
          isClickable
            ? e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick?.();
                }
              }
            : undefined
        }
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
      >
        {glowStyle ? (
          <div className="absolute pointer-events-none" style={glowStyle} />
        ) : null}
        {children}
      </div>
    </div>
  );
}
